import { RbacPermission } from '@agilelab/plugin-wb-rbac-common';
import { createPermission } from '@mainstage/plugin-permission-common';

export const insertDocumentsPermission = {
  ...createPermission({
    name: 'documents.document.insert',
    attributes: {},
  }),
  description:
    'Authorizes the insertion of a document into the database through its respective route. Refer to the documents documentation page for more information.',
  requiredModules: [],
};

export const documentsPermissions: RbacPermission[] = [
  insertDocumentsPermission,
];
